import { useState } from "react";
import { Button, Card, Col, Collapse, Form, Row, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { BsChevronLeft } from "react-icons/bs";
import { CiSearch } from "react-icons/ci";
import { FiCheckCircle } from "react-icons/fi";
import { IoIosArrowDropdown } from "react-icons/io";

const ManageSubcriptionPlans = () => {
    let [currentPlan, setCurrentPlan] = useState(true);
    const modulesData = [
        {
            id: "core-hr",
            title: "Core HR/Employee Management",
            subModules: [
                { id: "sm-1-switch-1", title: "Employee Database Management", defaultChecked: true },
                { id: "sm-1-switch-2", title: "HR Administration", defaultChecked: false },
                { id: "sm-1-switch-3", title: "HR Help Desk", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "workforce-mgmt",
            title: "Workforce Management",
            subModules: [
                { id: "sm-2-switch-1", title: "Time and Attendance", defaultChecked: false },
                { id: "sm-2-switch-2", title: "Leave Management", defaultChecked: true },
                { id: "sm-2-switch-3", title: "Shift Scheduling", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "talent-acquisition",
            title: "Talent Acquisition/Recruitment",
            subModules: [
                { id: "sm-3-switch-1", title: "Applicant Tracking System (ATS)", defaultChecked: true },
                { id: "sm-3-switch-2", title: "Onboarding", defaultChecked: true },
                { id: "sm-3-switch-3", title: "Talent Pools", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "payroll",
            title: "Payroll and Compensation",
            subModules: [
                { id: "sm-4-switch-1", title: "Payroll Processing", defaultChecked: true },
                { id: "sm-4-switch-2", title: "Benefits Administration", defaultChecked: true },
                { id: "sm-4-switch-3", title: "Compensation Management", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "performance-dev",
            title: "Performance and Development",
            subModules: [
                { id: "sm-5-switch-1", title: "Performance Management", defaultChecked: true },
                { id: "sm-5-switch-2", title: "Learning and Development (L&D)", defaultChecked: true },
                { id: "sm-5-switch-3", title: "Succession Planning", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "analytics-report",
            title: "Analytics and Reporting",
            subModules: [
                { id: "sm-6-switch-1", title: "HR Analytics", defaultChecked: true },
                { id: "sm-6-switch-2", title: "Custom Reports", defaultChecked: true },
            ],
            defaultChecked: true,
        },
    ];
    let [expandedModules, setExpandedModules] = useState({});

    let handleToggleCollapse = (moduleId) => {
        setExpandedModules((prevState) => ({
            ...prevState,
            [moduleId]: !prevState[moduleId],
        }));
    };

    let plansData = [
        {
            title: 'PROFESSIONAL',
            price: '$500',
            maxUser: '200',
            getStartWith: 'Everything in Essential HR +',
            features: [{
                title: '',
                list: ['Blueprint', 'CPQ', 'SalesSignals', 'Inventory management', 'Webhooks', 'Assignment rules', 'Validation rules', 'Google Ads integration']
            }]
        },
        {
            title: 'PREMIUM',
            price: '$500',
            maxUser: '200',
            getStartWith: 'Everything in Professional +',
            features: [{
                title: '',
                list: ['Zia - AI assistant', 'Territory management', 'Custom functions', 'Journey orchestration', 'Multi-user portals', 'Page layouts', 'Client scripts', 'Approval process', 'Sandbox']
            }]
        },
        {
            title: 'Enterprise',
            price: '$500',
            maxUser: '200',
            getStartWith: 'Everything in Premium +',
            features: [{
                title: '',
                list: ['Enhanced feature limits', 'Custom AI/ML platform', 'Advanced customization', 'Data preparation', 'Augmented Analytics', 'Data storytelling', 'Unified business insights', 'Advanced administration']
            }]
        }
    ]

    return (<>
        <div className="container-fluid py-3">
            {/* Plans List */}
            {currentPlan && (<>
                <div className="current-plan">
                    <h6 className="fw-semibold">Current Subscription Plans</h6>
                    <Card body className="mb-3">
                        <div className="hstack justify-content-between">
                            <div className="fs-4 fw-semibold">Essential HR +</div>
                            <Button variant="dark" className="ms-auto" onClick={() => setCurrentPlan(false)}>Manage Plan</Button>
                        </div>
                        <div className="mb-2">
                            <span className="fs-3 fw-semibold">$500</span><span className="small text-secondary"> / month</span>
                        </div>
                        <div className="fw-medium mb-2">Get Start with :</div>
                        <div className="fs-6 fw-semibold text-success">Basic +</div>
                        <div className="mt-3">
                            <div className="fs-6 fw-medium mb-2">Core HR/Employee Management</div>
                            <ul className="list-unstyled vstack gap-2 mb-0">
                                <li className="hstack gap-2">
                                    <FiCheckCircle size={16} /> <span>200 Users</span>
                                </li>
                                <li className="hstack gap-2">
                                    <FiCheckCircle size={16} /> <span>Prior Support</span>
                                </li>
                                <li className="hstack gap-2">
                                    <FiCheckCircle size={16} /> <span>50 GB Storage</span>
                                </li>
                                <li className="hstack gap-2">
                                    <FiCheckCircle size={16} /> <span>Advanced Analytics</span>
                                </li>
                            </ul>
                        </div>
                    </Card>
                </div>
                <div className="available-plans">
                    <div className="hstack justify-content-between mb-2">
                        <h6 className="fw-semibold mb-0">Available Plans</h6>
                        <ToggleButtonGroup type="radio" name="subscriptionPlans" defaultValue={'monthly'}
                            className="p-1 border bg-white rounded-2 mb-2">
                            <ToggleButton className="border-0 rounded-2 px-4"
                                id='radio-monthly'
                                variant="outline-dark" value={'monthly'}>
                                Monthly
                            </ToggleButton>
                            <ToggleButton className="border-0 rounded-2 px-4"
                                id='radio-yearly'
                                type="radio"
                                variant="outline-dark" value={'yearly'}>
                                Yearly
                            </ToggleButton>
                        </ToggleButtonGroup >
                    </div>
                    <Row xs={1} md={2} lg={3} className="g-2 justify-content-center">
                        {plansData?.map((plan) => (
                            <Col>
                                <Card body className="border-0 h-100">
                                    <div className="fs-4 fw-semibold">{plan.title}</div>
                                    <div className="mb-2">
                                        <span className="fs-3 fw-semibold">{plan.price}</span><span className="small text-secondary"> / month</span>
                                    </div>
                                    <div className="text-secondary">Max User : {plan.maxUser}</div>
                                    <Button variant="outline-primary w-100 my-2">Upgrade</Button>
                                    <div className="fw-medium mb-2">Get Start with :</div>
                                    <div className="fs-6 fw-semibold text-success">{plan.getStartWith}</div>
                                    {plan.features.map((feature) => (
                                        <div className="mt-3">
                                            <div className="fs-6 fw-medium mb-2">{feature.title}</div>
                                            <ul className="list-unstyled vstack gap-2 mb-0">
                                                {feature.list.map((list) => (
                                                    <li className="hstack gap-2 mt-2">
                                                        <FiCheckCircle size={16} /> <span>{list}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </>)}
            {/* // Plans List END // */}
            {/* Manage Plan */}
            {!currentPlan && (
                <Card body>
                    <div className="hstack gap-2">
                        <Button variant="light" className='border rounded-circle p-1'
                            onClick={() => setCurrentPlan(true)}>
                            <BsChevronLeft size={18} />
                        </Button>
                        <div className="hstack flex-fill">
                            <span className="fs-6 fw-semibold">Manage Plan</span><span className="badge text-bg-success ms-2">Premium</span>
                        </div>
                        <div className="hstack gap-2 ms-auto">
                            <div className="col-12 col-md-4 col-xl-auto">
                                <div className="search-box border rounded-2">
                                    <label htmlFor="modulesSearch" className="searchbutton fs-16" type="button">
                                        <CiSearch />
                                    </label>
                                    <input type="search" id="modulesSearch" placeholder="Modules"
                                        className="searchfield bg-body-tertiary rounded-2" />
                                </div>
                            </div>
                            <Button variant="dark">Save</Button>
                        </div>
                    </div>
                    <div className="fs-6 fw-medium mt-2">Below Modules are Based on your packages :</div>
                    <div className="tbl-container rounded-table rounded-2 mt-2">
                        <div className="table-responsive overflow-y-auto" style={{ maxHeight: 'calc(100vh - 192px)' }}>
                            <table className="table table-striped mb-0">
                                <thead className="table-header table-light">
                                    <tr>
                                        <th style={{ width: '70%' }}>MODULES</th>
                                        <th className="text-center" style={{ width: '30%' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modulesData.map((module) => (<>
                                        <tr key={module.id}>
                                            <td style={{ width: '70%' }}>
                                                <div className="hstack gap-2" role="button"
                                                    onClick={() => handleToggleCollapse(module.id)}>
                                                    <IoIosArrowDropdown size={18} className="link-dark"
                                                        style={{
                                                            transform: expandedModules[module.id] ? "rotate(180deg)" : "rotate(0deg)",
                                                            transition: "transform 0.3s ease-in-out"
                                                        }}
                                                    />
                                                    <span className="fw-medium">{module.title}</span>
                                                </div>
                                            </td>
                                            <td className="text-center" style={{ width: '30%' }}>
                                                <Form.Check type="switch" className="fs-6"
                                                    id={`main-module-${module.id}-switch`}
                                                    defaultChecked={module.defaultChecked}
                                                />
                                            </td>
                                        </tr>
                                        <tr className="p-0">
                                            <td colSpan={2} className="p-0 border-0">
                                                <Collapse in={expandedModules[module.id]}>
                                                    <div>
                                                        <table className="table table-sm mb-0">
                                                            <tbody>
                                                                {module.subModules.map((subModule) => (
                                                                    <tr key={subModule.id}>
                                                                        <td className="ps-4" style={{ width: '70%' }}>
                                                                            <span className="ps-2">{subModule.title}</span>
                                                                        </td>
                                                                        <td className="text-center" style={{ width: '30%' }}>
                                                                            <Form.Check type="switch" className="fs-6"
                                                                                id={`sub-module-${subModule.id}-switch`}
                                                                                defaultChecked={subModule.defaultChecked}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </Collapse>
                                            </td>
                                        </tr>
                                    </>))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Card>
            )}
            {/* // Manage Plan END // */}
        </div>
    </>);
}

export default ManageSubcriptionPlans;